import clsx from 'clsx';
import { ReactNode } from 'react';
import { makeStyles } from '@mui/styles';
import { Button } from '@qrios/frontend-library';
import { Box, Typography } from '@mui/material';
import { RefreshOutlined } from '@mui/icons-material';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  fullSize: {
    width: '100%',
    height: '100%'
  }
}));

interface Props {
  children: ReactNode;
  refreshHandler?: () => void;
  message?: ReactNode;
}

const ErrorBoundary = ({ children, message, refreshHandler, ...props }: Props) => {
  const classes = useStyles();
  if (message) {
    return (
      <Box {...props} className={clsx(classes.container, classes.fullSize)}>
        <Box>
          <Typography variant="h4">{message}</Typography>
          {refreshHandler && (
            <Box className={classes.container}>
              <Button
                text="Refresh"
                onClick={refreshHandler}
                endIcon={<RefreshOutlined />}
                variant="text"
                data-testid="button-refresh"
              />
            </Box>
          )}
        </Box>
      </Box>
    );
  }
  return <>{children}</>;
};

export default ErrorBoundary;
